// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import ManageInventory from '@/components/inventory/manage';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function EditInventory() {

    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  
    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };
  
    useEffect(() => {
        getAccessStatus();
    }, []);
    
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    const { data: inventory } = useQuery(
        ['inventory', id],
        () => Fetch.get({ url: `/Inventory?id=${id}` }),
        { enabled: !!id }
    );

    const { data: inventoryCategory } = useQuery(
        ['inventoryCategory', inventory?.InventoryCategoryID],
        () => Fetch.get({ url: `/InventoryCategory?id=${inventory.InventoryCategoryID}` }),
        { enabled: !!inventory?.InventoryCategoryID }
    );

    const { data: inventorySubcategory } = useQuery(
        ['inventorySubcategory', inventory?.InventorySubcategoryID],
        () => Fetch.get({ url: `/InventorySubcategory?id=${inventory.InventorySubcategoryID}` }),
        { enabled: !!inventory?.InventorySubcategoryID }
    );

    if (!inventory) return null;

    return (
        <div>
            <ManageInventory isNew={false} manageInventory={inventory} inventoryCategory={inventoryCategory} inventorySubcategory={inventorySubcategory}
                accessStatus={accessStatus} />
        </div>
    );
}

export default EditInventory;

export const Route = createFileRoute('/_authenticated/inventory/$id')({ component: EditInventory })
